// NewMortgageLoanForm.js
import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";


const NewAutoLoanForm = () => {
    const [bankLoanNumber, setBankLoanNumber] = useState(null);
    const [amortBool, setAmortBoolean] = useState(true);
    const [lenderChoices, setLenderChoices] = useState([]);
    const [selectedLender, setSelectedLender] = useState('');
    const [loanAmount, setLoanAmount] = useState(null);
    const [rateTypeChoices, setRateTypeChoices] = useState([]);
    const [selectedRateType, setSelectedRateType] = useState('');
    const [annualInterestRate, setAnnualInterestRate] = useState(null);
    const [originationDate, setOriginationDate] = useState(null);
    const [firstPaymentDate, setFirstPaymentDate] = useState(null);
    const [loanTermYears, setLoanTermYears] = useState(null);
    const [maturityDate, setMaturityDate] = useState(null);
    const [noPaymentsPerYear, setNoPaymentsPerYear] = useState(12);
    const [totalClosingCosts, setTotalClosingCosts] = useState(null);
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [vehicleYear, setVehicleYear] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        const fetchLenderChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/lender-choices/');
                setLenderChoices(response.data);
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchLenderChoices();
    }, []);

    useEffect(() => {
        const fetchRateTypeChoices = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/financing/rate-type-choices/');
                setRateTypeChoices(response.data);
            } catch (error) {
                console.error('Error fetching rate type choices:', error);
                setError('Failed to fetch rate type choices.');
            }
        };
        fetchRateTypeChoices();
    }, []);

    // This function toggles the amortization boolean state
    const handleAmortToggle = () => {
        setAmortBoolean(!amortBool);
  };

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newAutoLoanData = {
            'bank_loan_number': bankLoanNumber,
            'amortizing': amortBool,
            'lender': selectedLender,
            'amount': loanAmount,
            'rate_type': selectedRateType,
            'initial_interest_rate': annualInterestRate,
            'origination_date': originationDate,
            'first_payment_date': firstPaymentDate,
            'loan_term_in_years': loanTermYears,
            'maturity_date': maturityDate,
            'n_payments_per_year': noPaymentsPerYear,
            'total_closing_costs': totalClosingCosts,
            'vehicle_make': vehicleMake,
            'vehicle_model': vehicleModel,
            'vehicle_year': vehicleYear,
        }

        // if (titleDocument) {
        //     newAutoLoanData.append('title_document', titleDocument);
        // }

        try {
            const response = await axios.post('/api/balance_sheet/financing/auto_loans/', newAutoLoanData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            navigate(`/balance_sheet/financing/auto_loans/${response.data.id}/`);


            // Now you can toggle visibility for land and structure forms
        } catch (error) {
            console.error('Error creating auto loan:', error);
            setError('There was an error creating the auto loan. Please check your input.');
        }
    };

  return (
        <div className="container mt-4" style={{marginBottom: '20px'}}>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Amortizing Loan:
                    </label>
                    <input
                        type="checkbox"
                        checked={amortBool}
                        onChange={handleAmortToggle}
                        className="ml-2"
                        style={{ marginLeft: '15px', verticalAlign: 'middle' }} // This ensures the checkbox aligns nicely with the label
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="lender" className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>Lender:</label>
                    <select
                        id="lender"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedLender}
                        onChange={(e) => setSelectedLender(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a lender</option>
                        {lenderChoices.map(([id, name]) => (
                            <option key={id} value={id}>{name}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Bank Loan
                        Number:</label>
                    <input
                        type="number"
                        value={bankLoanNumber}
                        onChange={(e) => setBankLoanNumber(parseInt(e.target.value, 10))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan
                        Amount:</label>
                    <input
                        type="number"
                        value={loanAmount}
                        onChange={(e) => setLoanAmount(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="rateType" className="text-right d-inline-block"
                           style={{width: '200px', textAlign: 'right'}}>Interest Rate Type:</label>
                    <select
                        id="rateType"
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        value={selectedRateType}
                        onChange={(e) => setSelectedRateType(e.target.value)}
                        required
                    >
                        <option value="" disabled>Select a rate type</option>
                        {rateTypeChoices.map(([value, label]) => (
                            <option key={value} value={value}>{label}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Annual
                        Interest Rate (%):</label>
                    <input
                        type="number"
                        value={annualInterestRate}
                        onChange={(e) => setAnnualInterestRate(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Number of
                        Payments (per year):</label>
                    <input
                        type="number"
                        value={noPaymentsPerYear}
                        onChange={(e) => setNoPaymentsPerYear(parseInt(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Origination
                        Date:</label>
                    <input
                        type="date"
                        value={originationDate ? originationDate : ""}
                        onChange={(e) => setOriginationDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>First
                        Payment Date:</label>
                    <input
                        type="date"
                        value={firstPaymentDate ? firstPaymentDate : ""}
                        onChange={(e) => setFirstPaymentDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan Term
                        (Years):</label>
                    <input
                        type="number"
                        value={loanTermYears}
                        onChange={(e) => setLoanTermYears(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Maturity
                        Date:</label>
                    <input
                        type="date"
                        value={maturityDate ? maturityDate : ""}
                        onChange={(e) => setMaturityDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Loan Closing Costs</label>
                    <input
                        type="number"
                        value={totalClosingCosts}
                        onChange={(e) => setTotalClosingCosts(parseFloat(e.target.value))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Make:</label>
                    <input
                        type="text"
                        value={vehicleMake}
                        onChange={(e) => setVehicleMake(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Model:</label>
                    <input
                        type="text"
                        value={vehicleModel}
                        onChange={(e) => setVehicleModel(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Year:</label>
                    <input
                        type="number"
                        value={vehicleYear}
                        onChange={(e) => setVehicleYear(parseInt(e.target.value, 10))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>

            <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
            </form>

            {error && <div className="text-danger">{error}</div>} {/* Display error messages */}
        </div>
    );
};
export default NewAutoLoanForm;